/* src/app/@framework/components/MenuControl/MenuControl.component.less */
zapp-menu .sidebar-container {
  height: 100%;
}
zapp-menu .vertical.bottom-menu p-tieredmenusub > ul.p-tieredmenu-submenu {
  top: unset !important;
  bottom: 0;
}
/*# sourceMappingURL=MenuControl.component.css.map */
